export const HOST = `//${window.location.host}${window.location.pathname}`;
